import { render } from "./ContactPage.vue?vue&type=template&id=a8de4f8a"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"
script.render = render

export default script